import { AssignNewInterviewModal } from './AssignNewInterviewModal';

export default AssignNewInterviewModal;